import { render } from "./CardCover.vue?vue&type=template&id=6b307814"
import script from "./CardCover.vue?vue&type=script&lang=js"
export * from "./CardCover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__